module.exports = {
	title: 'Palát Legal',
	siteUrl: 'https://www.palatlegal.cz/',
	description: 'Podnikejte, vymýšlejte a tvořte! Starost o vaše právní záležitosti už nechte na mně.',
	lang: 'cs',
};
